import { PROVIDER_TYPE_ENUM } from 'modules/inventory/provider/common/constants/provider.types';

export enum PROVIDER_DATA_TYPE_ENUM {
  STRING = 'string',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
  ARRAY = 'array',
}

export interface IProviderField {
  _id?: string;
  label: string;
  providerType: PROVIDER_TYPE_ENUM;
  dataType: PROVIDER_DATA_TYPE_ENUM;
  required: boolean;
  defaultValue?: any;
  fixedValues?: Array<string | number | boolean>;
}
